export { default as Manager } from './Manager';
export { default as Target } from './Target';
export { default as Popper, placements } from './Popper';
export { default as Arrow } from './Arrow';


//////////////////
// WEBPACK FOOTER
// ../react-popper/lib/react-popper.js
// module id = 231
// module chunks = 22